export const readingSkills = [
  {
    id: "ckmmf9uwt00013e5aufnod848",
    text: "What the Text Says",
  },
  {
    id: "ckmmfdxcj00033e5aq2r9soen",
    text: "Main Idea",
  },
  {
    id: "ckmmfe5w800053e5ahc1l0vwv",
    text: "Key Details",
  },
  {
    id: "ckmmfeego00073e5axsfuczqm",
    text: "Summarization",
  },
  {
    id: "ckmmfen8l000a3e5a3yci813m",
    text: "Theme",
  },
  {
    id: "ckmmfex1j000c3e5anupm1gfv",
    text: "Connecting People, Events, Ideas",
  },
  {
    id: "ckmmffjca000e3e5aa40p4z86",
    text: "Word Meaning & Choice",
  },
  {
    id: "ckmmffx0j000g3e5adkygp3dd",
    text: "Text Structure",
  },
  {
    id: "ckmmfg98e000i3e5ahym5p9aj",
    text: "Point of View & Purpose",
  },
  {
    id: "ckmmfglnv000k3e5arlboodf3",
    text: "Interpret Multimedia",
  },
  {
    id: "ckmmfh3s1000m3e5aswc22jgv",
    text: "Arguments & Claims",
  },
];
